import styled, { css } from 'styled-components';
import Button from '../base/button';

export const Wrapper = styled.div`
	margin-bottom: 6rem;
`;

export const AccordionLine = styled.div`
	margin-bottom: 2rem;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	transition: border 200ms ease;

	${({ active }) =>
		active &&
		css`
			border-bottom: 1px solid transparent;
			border-color: ${({ theme }) => theme.colors.borderDark};
		`};
`;

export const Line1 = styled.div`
	width: 1.4rem;
	height: 2px;
	background-color: ${({ theme }) => theme.colors.primary};
	transition: background-color 200ms, transform 400ms;
`;

export const Line2 = styled.div`
	position: absolute;
	height: 1.4rem;
	width: 2px;
	background-color: ${({ theme }) => theme.colors.primary};
	transition: background-color 200ms, transform 400ms;
	transform-origin: center;
`;

export const IconWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	flex-shrink: 0;
	width: 2.2rem;
	height: 2.2rem;
	margin-left: 1.5rem;
	transition: transform 200ms;
`;

export const AccordionTrigger = styled.button`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 2.5rem 3rem;
	color: ${({ theme }) => theme.colors.textDark};
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	cursor: pointer;
	transition: color 150ms ease, border 200ms ease;
	background-color: inherit;
	font-size: inherit;
	letter-spacing: inherit;
	width: 100%;

	&:hover {
		color: ${({ theme }) => theme.colors.primary};
	}

	${({ active }) =>
		active &&
		css`
			color: ${({ theme }) => theme.colors.primary};

			${Line1} {
				transform: rotate(-180deg);
			}

			${Line2} {
				transform: rotate(90deg);
			}
		`};
`;

export const AccordionContent = styled.div`
	padding: 0 3rem;
	position: relative;
	${({ buttonString }) =>
		buttonString &&
		css`
			padding-bottom: 2rem;
		`};
`;

// Kept in normal flow (not absolutely positioned) so it always sits below the content and can't overlap it.
export const AccordionButton = styled(Button)`
	display: flex;
	width: fit-content;
	margin: 2rem 0 0 auto;
`;
